// import { setEventStoreProps } from 'core/toast';
import store from '../core/store';
export const setupToast = async () => {
    const toast = await import(/* webpackChunkName: "toast" */ 'core/toast');

    // call presetup which calls countdown which fetches server time/countdown.
    const instance = toast.default();
    await instance.presetup(); // TODO: This line is breaking the site

    // set event store props immediately after presetup
    setEventStoreProps(instance);

    // setup() then has to be called in next step ( but can be none-blocking )
    return toast.default();
};

/**
 * Compatibility replacement for removing toast..
 */
export const setupPostLaunchToast = () => {
    // Skip creating toast at all..
    // And mimic expected event store dependencies.

    const { event } = store().state;

    event.secondTick = 0;
    event.timeToEvent = 0;
    event.timeToEventClamped = 0;
    event.countDownTo = 0;

    event.isCountdown = false;
    event.isCountdown2Hours = false;
    event.isCountdownFinalSeq = false;
    event.isQnA = false;
    event.isLive = false;
    event.isFinished = true;

    event.showGuestLocations = false;
    event.countdownProgress = 0;
    event.shopIsLive = true;
    event.showLaunchHeader = false;
};

export const setupShopify = async () => {
    const shopify = await import(/* webpackChunkName: "shopify" */ 'api/shopify');
    shopify.default._init();
    // await shopify.default._init();
};
